import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import { TableOutlined } from '@ant-design/icons';
import { DOWNLOAD_EXCEL } from '../state/downolad_docs/types';
import { RESOURCE } from '../config/constants/alerts';
import { STATES } from '../config/constants/contractStates';
import PropTypes from 'prop-types';

const ExportListExcel = ({ activeTab, downloadExcel }) => {

  const [activeState, setActiveState] = useState(STATES.VALIDATE_BY_ALL);

  useEffect(() => {
    const states = {
      0: STATES.VALIDATE_BY_ALL,
      1: STATES.CREATED,
      2: STATES.AWAITING_VALIDATION,
      3: STATES.SENDED,
      4: STATES.AWAITING_SIGN,
      5: STATES.AWAITING_NOTARY,
      6: STATES.CANCELED,
      7: STATES.OBJECTED,
      8: STATES.FINALIZED,
      9: ''
    };
    setActiveState(states[activeTab]);
  }, [activeTab]);

  return (
    <Button
      icon={<TableOutlined />}
      className="btn-responsive"
      onClick={() => downloadExcel({ activeState })}
    >
      Descargar lista excel
    </Button>
  );
};

ExportListExcel.propTypes = {
  activeTab: PropTypes.string.isRequired,
  downloadExcel: PropTypes.func.isRequired,
};

const action = (dispatch) => ({
  downloadExcel: (params) => dispatch({ type: DOWNLOAD_EXCEL, payload: { params, resource: RESOURCE.DOWNLOAD_EXCEL } }),
});

export default connect(null, action)(ExportListExcel);